<template>
    <div>
        <b-modal ref="templateModal" centered header-bg-variant="primary" @ok="saveTemplate" :ok-disabled="!state">
            <div slot="modal-header" class="w-100">
                <h2 class="text-center">Save template</h2>
            </div>

            <b-form-group
                    id="fieldset1"
                    description=""
                    label="Enter template name"
                    label-for="name-input"
                    :invalid-feedback="invalidFeedback"
                    :valid-feedback="validFeedback"
                    f :state="state"
            >
                <b-form-input id="name-input" :state="state" v-model.trim="name" @keypress.enter.native="pressedEnter"></b-form-input>
            </b-form-group>

            <div slot="modal-ok">Confirm</div>
        </b-modal>

        <b-modal ref="successModal" centered header-bg-variant="primary" ok-only>
            <div slot="modal-header" class="w-100">
                <h2 class="text-center">Success</h2>
            </div>

            Your template was saved successfully.
        </b-modal>

        <b-modal ref="maxLimitModal" centered header-bg-variant="primary" ok-only>
            <div slot="modal-header" class="w-100">
                <h2 class="text-center">Max limit reached</h2>
            </div>

            You cannot save more than 20 templates.
        </b-modal>

        <b-modal ref="failModal" centered header-bg-variant="danger" ok-only>
            <div slot="modal-header" class="w-100">
                <h2 class="text-center">Fail</h2>
            </div>

            Your template could not be saved.
        </b-modal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "SaveTemplate",

        mounted() {
            this.name = "Template " + this.getDeviceName(this.$route.params.id);
            this.$root.$on('show-save-modal', () => {
                this.$refs.templateModal.show()
            });
        },

        destroyed() {
            this.$root.$off('show-save-modal');
        },

        computed: {
            ...mapGetters({
                getDeviceName: 'virtualDevice/deviceName'
            }),

            state() {
                return this.name.length >= 4 && this.name.length <= 20
            },

            invalidFeedback() {
                if (this.name.length > 4 && this.name.length <= 20) {
                    return ''
                } else if (this.name.length > 20) {
                    return 'Template name must be no more than 20 characters'
                } else if (this.name.length > 0) {
                    return 'Enter at least 4 characters'
                } else {
                    return 'Template name must not be empty'
                }
            },

            validFeedback() {
                return this.state === true ? 'Ready' : ''
            }
        },

        data() {
            return {
                name: ""
            }
        },

        methods: {
            pressedEnter() {
                if (this.state) {
                    this.$refs.templateModal.hide();
                    this.saveTemplate();
                }
            },

            saveTemplate() {
                let timezoneOffset = new Date().getTimezoneOffset();

                this.$axios({
                    method: 'post',
                    url: '/save-parameters-template',
                    data: {
                        data: {
                            id: this.$route.params.id,
                            name: this.name,
                            timezoneOffset: timezoneOffset
                        }
                    },
                    timeout: 10000
                }).then((response) => {
                    if (response.data.msg === "success") {
                        this.$refs.successModal.show();
                    } else {
                        this.$refs.maxLimitModal.show();
                    }
                }).catch(() => {
                    this.$refs.failModal.show();
                });
            }
        }
    }
</script>

<style scoped>

</style>